// extracted by mini-css-extract-plugin
module.exports = {"stepsWrapper":"confirmation-next-steps_stepsWrapper__SMg2Y","step":"confirmation-next-steps_step__7NUaE","stepNumber":"confirmation-next-steps_stepNumber__UJdZj"};